import { create } from "zustand";

export const useRiskExistingControlsStore = create((set, get) => ({
    data: [],
    loading: false,
    error: null,
    pagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 10,
    },
    searchQuery: "",
    columnFilters: {},
    sort: null,
    baseParams: {},
    uniqueOwners: [],
    uniqueValues: {},

    setData: (data) => set({ data }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error, loading: false }),
    setPagination: (pagination) =>
        set((state) => ({ pagination: { ...state.pagination, ...pagination } })),
    setSearchQuery: (query) => set({ searchQuery: query }),
    setColumnFilters: (filters) => set({ columnFilters: filters }),
    setSort: (sort) => set({ sort }),
    setBaseParams: (params) => set({ baseParams: params }),
    setUniqueOwners: (owners) => set({ uniqueOwners: owners }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues: uniqueValues || {} }),
    clearError: () => set({ error: null }),
}));
